require('./bootstrap');
import 'datatables.net-responsive-bs4'
